var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"block-search"}},[_c('div',{staticClass:"tl-container",attrs:{"id":"tl-search-form"}},[_c('a',{attrs:{"href":"#","rel":"nofollow","target":"_blank"}},[_vm._v(" ")])])])])
}]

export { render, staticRenderFns }